import { system } from '@styled-system/core';
var config = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config.bgImage = config.backgroundImage;
config.bgSize = config.backgroundSize;
config.bgPosition = config.backgroundPosition;
config.bgRepeat = config.backgroundRepeat;
export var background = system(config);
export default background;



//////////////////
// WEBPACK FOOTER
// /Users/dtantaru/bit-ml/node_modules/@styled-system/background/dist/index.esm.js
// module id = 163
// module chunks = 0 2